import createBeAuthBrowser from '@besuites/auth/browser';
import { BEAUTH_API_ORIGINS, BEAUTH_LOGOUT_URL, BEAUTH_REFRESH_URL } from '@/config/beauth.config';

const beauthBrowser = createBeAuthBrowser({
    refreshUrl: BEAUTH_REFRESH_URL,
    logoutUrl: BEAUTH_LOGOUT_URL,
    apiOrigins: BEAUTH_API_ORIGINS,
});

export default beauthBrowser;
